import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SubPathComponent } from '@dossier/shared/components/sub-path-layout/sub-path.component';
import { SubPathContentComponent } from '@dossier/shared/components/sub-path-layout/sub-path-content.component';
import { SubPathFooterComponent } from '@dossier/shared/components/sub-path-layout/sub-path-footer.component';
import { SubPathHeaderComponent } from '@dossier/shared/components/sub-path-layout/sub-path-header.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    SubPathComponent,
    SubPathFooterComponent,
    SubPathContentComponent,
    SubPathHeaderComponent
  ],
  exports: [
    SubPathComponent,
    SubPathFooterComponent,
    SubPathContentComponent,
    SubPathHeaderComponent
  ]
})
export class SubPathLayoutModule {
}
